const storefrontApiConfig = {
  access_token: "a3d30e5a83f7ef255246776a881f8ec4",
  shop: window.Shopify.shop,
  api_version: "2026-04",
};
class CatalogCollection extends HTMLElement {
  connectedCallback() {
    this.handle = this.dataset.collectionHandle;
    this.total = Number(this.dataset.productsCount);
    // this.loaded is the number of products already loaded on the page
    this.loaded = Number(this.dataset.loadedCount);
    this.container = this.querySelector('[data-catalog-products]');
    this.productsPerPrintPage = Number(this.container?.dataset.productsPerPrintPage) || 12;
    this.collectionHeader = this.querySelector('[data-catalog-collection-header]');

    if (this.dataset.showSku === 'true') {
      this.showSku = true;
    } else {
      this.showSku = false;
    }

    if (this.dataset.showPrice === 'true') {
      this.showPrice = true;
    } else {
      this.showPrice = false;
    }

    if (this.dataset.showStock === 'true') {
      this.showStock = true;
    } else {
      this.showStock = false;
    }

    if (!this.handle || !this.container) return;
    if (this.total <= this.loaded) return;

    this.loadRemainingProducts();
  }

  // Load Remaining Products
  async loadRemainingProducts() {
    let cursor = null;
    let hasNextPage = true;
    let loadedCount = 0;

    while (hasNextPage) {
      const data = await this.fetchProducts(cursor);
      const products = data.collection.products;

      products.nodes.forEach((product, index) => {
        const globalIndex = loadedCount + index;

        if (globalIndex >= this.loaded) {
          this.appendProduct(product, globalIndex);
        }
      });

      loadedCount += products.nodes.length;

      hasNextPage = products.pageInfo.hasNextPage;
      cursor = products.pageInfo.endCursor;
    }
  }

  // Append Product
  appendProduct(product, productIndex) {
    const printPageGrid = this.getPrintPageGrid(productIndex);
    printPageGrid.insertAdjacentHTML('beforeend', this.renderProduct(product));
  }

  // Get Print Page
  getPrintPage(productIndex) {
    const printPageIndex = Math.floor(productIndex / this.productsPerPrintPage);
    let printPage = this.container.querySelector(`[data-catalog-products-page="${printPageIndex}"]`);

    if (!printPage) {
      printPage = document.createElement('div');
      printPage.className = 'catalog-products-page';
      printPage.dataset.catalogProductsPage = printPageIndex;

      const printHeader = this.createPrintHeader();
      if (printHeader) {
        printPage.appendChild(printHeader);
      }

      printPage.appendChild(this.createPrintPageGrid());
      this.container.appendChild(printPage);
    }

    return printPage;
  }

  // Get Print Page Grid
  getPrintPageGrid(productIndex) {
    const printPage = this.getPrintPage(productIndex);
    let printPageGrid = printPage.querySelector('[data-catalog-products-page-grid]');

    if (!printPageGrid) {
      printPageGrid = this.createPrintPageGrid();
      printPage.appendChild(printPageGrid);
    }

    return printPageGrid;
  }

  // Create Print Header
  createPrintHeader() {
    if (!this.collectionHeader) return null;

    const printHeader = this.collectionHeader.cloneNode(true);
    printHeader.classList.remove('catalog-collection-header--screen');
    printHeader.classList.add('catalog-collection-header--print');
    printHeader.removeAttribute('data-catalog-collection-header');
    printHeader.setAttribute('aria-hidden', 'true');

    return printHeader;
  }

  // Create Print Page Grid
  createPrintPageGrid() {
    const printPageGrid = document.createElement('div');
    printPageGrid.className = 'catalog-products-page-grid';
    printPageGrid.dataset.catalogProductsPageGrid = '';

    return printPageGrid;
  }

  // Fetch Products
  async fetchProducts(cursor = null) {
    try {
      const query = `
        query CatalogCollectionProducts($handle: String!, $cursor: String) {
          collection(handle: $handle) {
            products(first: 250, after: $cursor) {
              pageInfo {
                hasNextPage
                endCursor
              }
              nodes {
                title
                handle
                onlineStoreUrl
                availableForSale
                featuredImage {
                  url
                  altText
                }
                priceRange {
                  minVariantPrice {
                    amount
                    currencyCode
                  }
                }
                variants(first: 1) {
                  nodes {
                    sku
                    availableForSale
                  }
                }
              }
            }
          }
        }
      `;

      const accessToken = storefrontApiConfig.access_token;
      const shop = storefrontApiConfig.shop;
      const apiVersion = storefrontApiConfig.api_version;
      const url = `https://${shop}/api/${apiVersion}/graphql.json`;

      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': accessToken,
        },
        body: JSON.stringify({
          query,
          variables: {
            handle: this.handle,
            cursor,
          },
        }),
      });

      const result = await response.json();
      return result.data;

    } catch(error) {
      console.error('Error fetching product data:', error);
    }
  }

  // Render Product
  renderProduct(product) {
    const image = product.featuredImage;
    const variant = product.variants.nodes[0];
    const price = product.priceRange.minVariantPrice;

    return `
      <article class="catalog-product productitem">
        <div class="productitem__container">
          <div class="productitem__image-container">
            ${
              image
                ? `
                  <a href="${product.onlineStoreUrl || `/products/${product.handle}`}" class="productitem--image-link">
                    <img
                    class="catalog-product-image"
                      src="${image.url}"
                      alt="${image.altText || product.title}"
                      loading="lazy"
                    >
                  </a>
                `
                : ''
            }
          </div>
          
          <div class="productitem--info">
            <h2 class="productitem--title recently-viewed-title">
              <a href="${product.onlineStoreUrl || `/products/${product.handle}`}">
                ${product.title}
              </a>
            </h2>

            ${
              this.showSku && variant?.sku
                ? `<span class="productitem--sku">SKU: ${variant.sku}</span>`
                : ''
            }

            ${
              this.showPrice
                ? `<div class="price productitem__price">
                    <div class="price__current">
                      $${Number(price.amount).toFixed(2)}
                    </div>
                  </div>`
                : ''
            }

            ${
              this.showStock
                ? `<div class="productitem__stock-level">
                    <div class="product-stock-level-wrapper">
                      <span 
                        class="product-stock-level ${product.availableForSale ? 'product-stock-level--high' : 'product-stock-level--none'}"
                      >
                        <span class="product-stock-level__text">
                          <div class="product-stock-level__badge-text">
                            ${product.availableForSale ? 'In stock' : 'Out of stock'}
                          </div>
                        </span>
                      </span>
                    </div>
                  </div>`
                : ''
            }
          </div>
        </div>
      </article>
    `;
  }
}

customElements.define('catalog-collection', CatalogCollection);

// Print Date
function printDate() {
  const printDateElement = document.querySelector('.catalog-print-date-text');
  if (!printDateElement)return;
  const currentDate = new Date();
  const formattedDate = currentDate.toLocaleDateString(undefined, { year: 'numeric', month: 'numeric', day: 'numeric' });
  printDateElement.textContent = `Inventory status as of ${formattedDate}`;
  setCatalogPrintDatePageRule(formattedDate);
}

// Set Catalog Print Date Page Rule
function setCatalogPrintDatePageRule(formattedDate) {
  let style = document.getElementById('catalog-print-date-page-rule');

  if (!style) {
    style = document.createElement('style');
    style.id = 'catalog-print-date-page-rule';
    document.head.appendChild(style);
  }

  style.textContent = `
    @page {
      @bottom-left {
        content: "Inventory status as of ${formattedDate}";
        font-size: 10pt;
        line-height: 1.2;
      }
    }

    @media print {
      .catalog-print-date {
        display: none;
      }
    }
  `;
}

printDate();